module.exports = __webpack_public_path__ + "static/media/FES_Selbsttest_untertitelt.73e35208.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle25/FES_Selbsttest_untertitelt.mp4
 ** module id = 385
 ** module chunks = 0
 **/